import { request } from "../lib/requestHelper";

export const fetchNotificationsService = async () => {
    return await request("api/fetch-notifications", { method: "GET" });
};
